import React, { Component } from 'react';

import Board from '@appblocks/frontend/client/boards/Board';
import Header from '@appblocks/frontend/client/Header';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import { Buffer } from 'buffer';
import { AutoSizer, List } from 'react-virtualized';
import Select from 'react-select';
import saveAs from 'file-saver';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { ConsoleLogger } from 'rp2040js';
import {
    RxAlignLeft,
    RxAlignRight,
    RxAlignTop,
    RxAlignBottom,
    RxSpaceEvenlyVertically,
    RxSpaceEvenlyHorizontally,
    RxGear,
} from 'react-icons/rx';
import { MdOutlineSwapVert } from 'react-icons/md';
import { FaExclamationTriangle } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import DraggableElement from '@appblocks/frontend/client/Components/DraggableElement';
import DraggableElementWrapper from '@appblocks/frontend/client/Components/DraggableElementWrapper';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Resizable from '@appblocks/frontend/client/Components/Resizable';


const capabilitiesOptions = require('@appblocks/platforms/capabilities.json');

const axios = require('axios');

const transformWrapperRef = React.createRef();
const svgRef = React.createRef();
const selectAreaRef = React.createRef();
const selectAreaStateRef = React.createRef();
const scaleRef = React.createRef();


const startMarker = '<!--PINS_START--><g>';
const endMarker = '</g><!--PINS_END-->';


let debounce;
const debounceTimeout = 500;


const runtimeOptions = [
    {
        value: 'tios',
        label: 'TIOS',
    },
    {
        value: 'zephyr',
        label: 'Zephyr RTOS',
    },
    {
        value: 'micropython',
        label: 'MicroPython',
    },
    {
        value: 'arduino',
        label: 'Arduino',
    },
];

const uploaderOptions = [
    {
        value: 'udp',
        label: 'TiOS UDP',
    },
    {
        value: 'esptool',
        label: 'esptool.py',
    },
    {
        value: 'jlink',
        label: 'JLink',
    },
    {
        value: 'usbstorage',
        label: 'USB Storage',
    },
];

const ControlButton = React.memo((props) => {
    return (
        <OverlayTrigger
            placement="right"
            overlay={(
                <Tooltip style={{ position: 'absolute' }}>
                    {props.tooltipText}
                </Tooltip>
            )}
        >
            <Button
                size="sm"
                variant="light"
                onClick={props.onClick}
                disabled={props.disabled}
                style={{ width: '30px', height: '30px' }}
            >
                {props.children}
            </Button>
        </OverlayTrigger>
    );
});

class PageBoardDesigner extends Component {
    constructor(props) {
        super(props);
        this.svgPinsMap = new Map();
        selectAreaStateRef.current = {
            isSelecting: false,
            x: 0,
            y: 0,
            startX: 0,
            startY: 0,
            width: 0,
            height: 0,
        };
        scaleRef.current = 1;

        this.state = {
            svgSource: '',
            pins: [],
            svgPins: [],
            propsPins: [],
            editingPin: undefined,
            boardConfig: {},
            pinsToAdd: 1,
            svgPinsErrors: [],
            width: 0,
            height: 0,
            templateCreatorModal: false,
            template: {
                colorBoard: '#00c486',
                colorSoc: '#666666',
                colorText: '#FFFFFF',
                textValue: 'Board',
                widthSoc: 100,
                heightSoc: 100,
                width: 300,
                height: 600,
                pinsLeft: 20,
                pinsRight: 20,
            },
            selectPinOptions: [],
            pinProps: [],
            addPinDirection: 'down',
            history: [],
            historyIndex: -1,
            isPanningDisabled: false,
            settingsModal: false,
            settings: {
                useCustomSpacing: false,
                pinSpacing: 2,
            },
            socEditorModal: false,
            socEditorState: {
                colorSoc: '#666666',
                colorText: '#FFFFFF',
                textValue: 'Board',
                widthSoc: 100,
                heightSoc: 100,
                centerChip: false,
            },
        };

        this.chipDragState = {
            isDragging: false,
            startX: 0,
            startY: 0,
            lastX: 0,
            lastY: 0,
        };

        this.setSvgSource = this.setSvgSource.bind(this);
        this.addPin = this.addPin.bind(this);
        this.setPinValue = this.setPinValue.bind(this);
        this.setPeripheralValue = this.setPeripheralValue.bind(this);
        this.saveToLocalStorage = this.saveToLocalStorage.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
        this.clearAll = this.clearAll.bind(this);
        this.updatePinPosition = this.updatePinPosition.bind(this);
        this.spacePinsEvenly = this.spacePinsEvenly.bind(this);
        this.alignPins = this.alignPins.bind(this);
        this.flipPins = this.flipPins.bind(this);
        this.addSvgPin = this.addSvgPin.bind(this);
        this.deleteSvgPin = this.deleteSvgPin.bind(this);
        this.swapSvgPins = this.swapSvgPins.bind(this);
        this.generateSvgTemplate = this.generateSvgTemplate.bind(this);
        this.saveToHistory = this.saveToHistory.bind(this);
        this.undo = this.undo.bind(this);
        this.redo = this.redo.bind(this);
        this.handleChipMouseDown = this.handleChipMouseDown.bind(this);
        this.handleChipMouseMove = this.handleChipMouseMove.bind(this);
        this.handleChipMouseUp = this.handleChipMouseUp.bind(this);
        this.openSocEditor = this.openSocEditor.bind(this);
        this.closeSocEditor = this.closeSocEditor.bind(this);
        this.updateSocEditorState = this.updateSocEditorState.bind(this);
        this.applySocChanges = this.applySocChanges.bind(this);
    }

    componentDidMount() {
        // Add event listeners for keydown and keyup
        document.addEventListener('keydown', this.handleKeyDown);
        document.addEventListener('keyup', this.handleKeyUp);
        // Add window-level mouse event listeners
        window.addEventListener('mousemove', this.handleGlobalMouseMove);
        window.addEventListener('mouseup', this.handleGlobalMouseUp);
        // Add event listeners for chip dragging
        document.addEventListener('mousedown', this.handleChipMouseDown);
        document.addEventListener('mousemove', this.handleChipMouseMove);
        document.addEventListener('mouseup', this.handleChipMouseUp);
        // get from localstorage
        const svgSource = this.initSvgSource() || '';
        const svgPins = PlatformUtils.parseSvgPins(svgSource) || [];
        const { width, height } = this.getSvgSize(svgSource);
        const json = localStorage.getItem('board-designer-json');
        const pins = JSON.parse(localStorage.getItem('designer-pins')) || [];
        pins.forEach((pin) => {
            pin.selected = false;
        });
        const selectPinOptions = [
            {
                value: '',
                label: '',
            },
            ...pins.map(p => ({
                value: p.num,
                label: `${p.num}${p.description && ` - ${p.description} - ${p.description.replace('_', '')}`}`,
            })),
        ];

        if (json) {
            const parsed = JSON.parse(json);
            parsed.pins.forEach((pin) => {
                pin.selected = false;
            });
            const pins = [...parsed.pins];
            const selectPinOptions = [
                {
                    value: '',
                    label: '',
                },
                ...pins.map(p => ({
                    value: p.num,
                    label: `${p.num}${p.description && ` - ${p.description} - ${p.description.replace('_', '')}`}`,
                })),
            ];
            this.setState({
                boardConfig: parsed,
                pins: parsed.pins,
                svgPins,
                svgSource,
                width,
                height,
                selectPinOptions,
            }, () => {
                this.validateSvgPins();
                this.updateSvgPinsMap();
            });
            return;
        }

        this.setState({
            svgSource,
            pins,
            svgPins,
            width,
            height,
            selectPinOptions,
        }, () => {
            this.validateSvgPins();
            this.updateSvgPinsMap();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.svgSource !== this.state.svgSource) {
            this.saveToHistory();
        }
    }

    componentWillUnmount() {
        // Clean up event listeners
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keyup', this.handleKeyUp);
        window.removeEventListener('mousemove', this.handleGlobalMouseMove);
        window.removeEventListener('mouseup', this.handleGlobalMouseUp);
        // Remove event listeners for chip dragging
        document.removeEventListener('mousedown', this.handleChipMouseDown);
        document.removeEventListener('mousemove', this.handleChipMouseMove);
        document.removeEventListener('mouseup', this.handleChipMouseUp);
    }

    getPinProps(svgPins, pins) {
        const { svgPinsErrors } = this.state;
        if (svgPins === undefined) {
            svgPins = this.state.svgPins;
        }
        if (pins === undefined) {
            pins = this.state.pins;
        }

        // Create a map for quick pin lookups
        const pinsMap = new Map();
        for (let i = 0; i < pins.length; i++) {
            pinsMap.set(pins[i].num, pins[i]);
        }

        // Create a map for quick error lookups
        const errorsMap = new Map();
        for (let i = 0; i < svgPinsErrors.length; i++) {
            errorsMap.set(svgPinsErrors[i].index, svgPinsErrors[i].message);
        }

        // Map pins with their properties and errors
        return svgPins.map((pin, index) => {
            const pinDef = pinsMap.get(pin.num);
            const errorMessage = errorsMap.get(index);
            return {
                ...pin,
                ...pinDef,
                error: !!errorMessage,
                errorMessage: errorMessage || '',
            };
        });
    }

    handleKeyDown = (e) => {
        if (e.shiftKey && !this.state.isPanningDisabled) {
            this.setState({ isPanningDisabled: true });
        }
    }

    handleKeyUp = (e) => {
        if (!e.shiftKey && this.state.isPanningDisabled) {
            this.setState({ isPanningDisabled: false });
        }
    }

    handleGlobalMouseMove = (e) => {
        if (!selectAreaStateRef.current.isSelecting) {
            return;
        }

        const svgPos = svgRef.current.getBoundingClientRect();
        const scale = scaleRef.current;

        // Calculate current mouse position in SVG coordinates
        const currentX = (e.clientX - svgPos.x) / scale;
        const currentY = (e.clientY - svgPos.y) / scale;

        const selectArea = selectAreaStateRef.current;
        const { startX, startY } = selectArea;

        // Calculate width and height of selection area
        const newWidth = Math.floor(Math.abs(currentX - startX));
        const newHeight = Math.floor(Math.abs(currentY - startY));

        const x = Math.floor(Math.min(startX, currentX));
        const y = Math.floor(Math.min(startY, currentY));

        console.table({
            x,
            y,
            width: newWidth,
            height: newHeight,
        });

        // Update selection area state
        selectAreaStateRef.current = {
            ...selectArea,
            x,
            y,
            width: newWidth,
            height: newHeight,
        };
        // Update selection rectangle position and size
        selectAreaRef.current.setAttribute('x', x);
        selectAreaRef.current.setAttribute('y', y);
        selectAreaRef.current.setAttribute('width', newWidth);
        selectAreaRef.current.setAttribute('height', newHeight);

        clearTimeout(debounce);
        debounce = setTimeout(this.updateSelectedPins, 20);
    }

    handleGlobalMouseUp = () => {
        if (!selectAreaStateRef.current.isSelecting) {
            return;
        }

        // Compute final selection before clearing the area
        this.updateSelectedPins();

        // Reset selection area
        selectAreaStateRef.current = {
            isSelecting: false,
            x: 0,
            y: 0,
            startX: 0,
            startY: 0,
            width: 0,
            height: 0,
        };

        // Clear visual selection area
        if (selectAreaRef.current) {
            selectAreaRef.current.setAttribute('width', '0');
            selectAreaRef.current.setAttribute('height', '0');
        }
    }

    initSvgSource = () => {
        const svgSource = localStorage.getItem('designer-svgSource');
        return this.injectPinMarkers(svgSource);
    }

    injectSvgPins = (source, pins = []) => {
        if (source === '') {
            return source;
        }
        let startMarkerIndex = source.indexOf(startMarker);
        let endMarkerIndex = source.indexOf(endMarker);
        if ((startMarkerIndex === -1) !== (endMarkerIndex === -1)) {
            return;
        }

        if (startMarkerIndex === -1 && endMarkerIndex === -1) {
            source = this.injectPinMarkers(source);
            startMarkerIndex = source.indexOf(startMarker);
            endMarkerIndex = source.indexOf(endMarker);
        }
        let pinElements = '';
        const width = 18;
        const height = 18;

        if (pins.length > 0) {
            for (let i = 0; i < pins.length; i++) {
                const pin = pins[i];
                let x = pin.x + width / 3;
                if (String(pin.label).length > 1) {
                    x = pin.x + width / 8;
                }
                pinElements += `
    <g>
        <rect id="pin-${pin.id}" x="${pin.x}" y="${pin.y}" width="${width}" height="${height}" data-pin="${pin.num}" class="pin"></rect>
        <text class="pinLabel" x="${x}" y="${pin.y + width * 0.8}" fill="#666" font-size="${width / 20}em">${pin.label}</text>
    </g>
    `;
            }
        } else {
            pinElements = source.substring(startMarkerIndex + startMarker.length, endMarkerIndex);
        }
        const svgSourceStart = source.substring(0, startMarkerIndex);
        const svgSourceEnd = source.substring(endMarkerIndex + endMarker.length);
        return svgSourceStart
        + startMarker
        + pinElements
        + endMarker
        + svgSourceEnd;
    }

    injectPinMarkers = (source) => {
        if (!source) {
            return source;
        }
        if (source.indexOf(startMarker) > -1
            && source.indexOf(endMarker) > -1) {
            return source;
        }
        return source.replace('</svg>', `
            ${startMarker}
            ${endMarker}
        </svg>`);
    }

    saveToLocalStorage = () => {
        localStorage.setItem('designer-svgSource', this.state.svgSource);
        localStorage.setItem('designer-svgPins', JSON.stringify(this.state.svgPins));

        const json = this.getJSON();
        localStorage.setItem('board-designer-json', JSON.stringify(json));
    }

    setSvgSource = (svgSource) => {
        svgSource = this.injectSvgPins(svgSource);
        if (svgSource === undefined || svgSource === this.state.svgSource) {
            return;
        }
        const { width, height } = this.getSvgSize(svgSource);
        this.setState({
            svgSource,
            svgPins: PlatformUtils.parseSvgPins(svgSource),
            width,
            height,
        }, this.saveToLocalStorage);
    }

    getSvgSize = (svgsource) => {
        const parser = new DOMParser();
        const svg = parser.parseFromString(svgsource, 'image/svg+xml').documentElement;
        const svgSelector = svg.querySelector('svg');
        const width = svg.getAttribute('width') || 50;
        const height = svg.getAttribute('height') || 50;

        return {
            width: parseInt(width, 10),
            height: parseInt(height, 10),
        };
    }


    updateSvgSource = () => {
        const { svgPins, svgSource } = this.state;
        const startMarkerIndex = svgSource.indexOf(startMarker);
        const endMarkerIndex = svgSource.indexOf(endMarker);
        if (startMarkerIndex === -1 || endMarkerIndex === -1) {
            return;
        }
        const svgSourceStart = svgSource.substring(0, startMarkerIndex + startMarker.length);
        const svgSourceEnd = svgSource.substring(endMarkerIndex);

        this.setState({
            svgSource: this.injectSvgPins(svgSourceStart + svgSourceEnd, svgPins),
        }, () => {
            this.saveToLocalStorage();
            this.validateSvgPins();
        });
    }

    validateSvgPins = () => {
        const { svgPins, pins } = this.state;
        const svgPinsErrors = [];

        // Validate each pin
        svgPins.forEach((pin, index) => {
            // Check if pin number is required
            if (pin.num === '' && !Number.isNaN(parseInt(pin.label, 10))) {
                svgPinsErrors.push({
                    index,
                    message: 'Pin number is required when the label is a number',
                });
            }

            // Check for duplicate pin numbers
            if (pin.num !== '') {
                const duplicates = svgPins.filter(p => p.num === pin.num);
                if (duplicates.length > 1) {
                    svgPinsErrors.push({
                        index,
                        message: `Duplicate pin number: ${pin.num}`,
                    });
                }
            }
        });

        // Update state with errors and generate pin props
        this.setState({
            svgPinsErrors,
        }, () => {
            const pinProps = this.getPinProps(svgPins, pins);
            this.setState({ pinProps });
        });
    }

    addPin = () => {
        const { pins } = this.state;

        let newPin = {
            num: '',
            description: '',
            function: 'GPIO',
            constant: '',
            peripherals: [],
        };
        if (pins.length > 0) {
            newPin = {
                ...pins[pins.length - 1],
                num: (pins.length + 1).toString(),
                description: '',
                function: 'GPIO',
                constant: '',
                peripherals: [],
            };
        }
        pins.push(newPin);
        this.setState({
            pins,
            editingPin: pins.length - 1,
        });
    }

    setPeripheralValue = (index, j, key, value) => {
        const { pins } = this.state;
        pins[index].peripherals[j][key] = value;
        this.setState({ pins }, this.saveToLocalStorage);
    }

    setPinValue = (index, key, value) => {
        const { pins } = this.state;
        pins[index][key] = value;
        this.setState({ pins }, this.saveToLocalStorage);
    }

    updatePinPosition = (pin, data) => {
        const { node, x, y } = data;
        const nodePosBounds = node.getBoundingClientRect();
        const svgPos = svgRef.current.getBoundingClientRect();
        const deltaX = (x - nodePosBounds.left - 9) * this.state.width / svgPos.width;
        const deltaY = (y - nodePosBounds.top - 9) * this.state.height / svgPos.height;
        const { svgPins } = this.state;
        this.updateSvgPinsMap();

        for (let i = 0; i < svgPins.length; i++) {
            if (pin.id === svgPins[i].id || svgPins[i].selected) {
                const pinElement = this.svgPinsMap.get(svgPins[i].id);
                const newX = Math.round(pinElement.x + deltaX);
                const newY = Math.round(pinElement.y + deltaY);

                // Update pin rectangle position
                pinElement.pin.setAttribute('x', newX);
                pinElement.pin.setAttribute('y', newY);

                // Update label position
                const labelElement = pinElement.pin.parentElement.querySelector('.pinLabel');
                if (labelElement) {
                    // Adjust label position relative to pin
                    const labelX = newX + (String(svgPins[i].label).length > 1 ? 18 / 8 : 18 / 3);
                    const labelY = newY + 18 * 0.8;
                    labelElement.setAttribute('x', labelX);
                    labelElement.setAttribute('y', labelY);
                }

                // Update pin coordinates in state
                svgPins[i].x = newX;
                svgPins[i].y = newY;
            }
        }

        clearTimeout(debounce);
        debounce = setTimeout(() => {
            this.setState({
                svgPins,
            }, () => {
                this.updateSvgSource();
            });
        }, debounceTimeout);
    }


    updateSelectedPins = () => {
        const { svgPins } = this.state;
        const selectArea = selectAreaStateRef.current;
        const scale = scaleRef.current;

        if (svgPins.length !== this.svgPinsMap.size) {
            this.updateSvgPinsMap();
        }

        const svgPos = svgRef.current.getBoundingClientRect();
        const selectedPins = new Map();

        this.svgPinsMap.forEach((pin, id) => {
            selectedPins.set(id, false);
            const pinRect = pin.pin.getBoundingClientRect();

            // Convert pin position to SVG coordinates by removing the SVG offset and scale
            const pinX = (pinRect.x - svgPos.x) / scale;
            const pinY = (pinRect.y - svgPos.y) / scale;

            // Check if pin center point is within selection area
            const pinCenterX = pinX + (pinRect.width / (2 * scale));
            const pinCenterY = pinY + (pinRect.height / (2 * scale));

            if (pinCenterX >= selectArea.x
                && pinCenterX <= selectArea.x + selectArea.width
                && pinCenterY >= selectArea.y
                && pinCenterY <= selectArea.y + selectArea.height) {
                selectedPins.set(id, true);
            }
        });

        for (let i = 0; i < svgPins.length; i++) {
            svgPins[i].selected = selectedPins.get(svgPins[i].id);
        }
        this.setState({ svgPins });
    }

    spacePinsEvenly = (alignment) => {
        const axis = alignment === 'vertical' ? 'y' : 'x';
        let minPos = Infinity;
        let maxPos = -Infinity;
        const { svgPins, settings } = this.state;
        const selectedPins = [];

        for (let i = 0; i < svgPins.length; i++) {
            if (svgPins[i].selected) {
                minPos = Math.min(minPos, svgPins[i][axis]);
                maxPos = Math.max(maxPos, svgPins[i][axis]);
                selectedPins.push(svgPins[i]);
            }
        }
        selectedPins.sort((a, b) => a[axis] - b[axis]);

        // Calculate spacing based on settings
        const space = settings.useCustomSpacing
            ? (18 + settings.pinSpacing)
            : Math.round((maxPos - minPos) / (selectedPins.length - 1));

        const selectedPinsMap = new Map();
        for (let i = 0; i < selectedPins.length; i++) {
            selectedPins[i][axis] = minPos + i * space;
            selectedPinsMap.set(selectedPins[i].id, selectedPins[i]);
        }

        for (let i = 0; i < svgPins.length; i++) {
            if (selectedPinsMap.has(svgPins[i].id)) {
                svgPins[i] = selectedPinsMap.get(svgPins[i].id);
            }
        }
        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    alignPins = (alignment) => {
        const { svgPins } = this.state;
        let mathCompare;
        let axis;
        switch (alignment) {
            case 'left':
                mathCompare = Math.min;
                axis = 'x';
                break;
            case 'right':
                mathCompare = Math.max;
                axis = 'x';
                break;
            case 'top':
                mathCompare = Math.min;
                axis = 'y';
                break;
            case 'bottom':
                mathCompare = Math.max;
                axis = 'y';
                break;
            default:
                break;
        }
        const targetPos = mathCompare(...svgPins.filter(pin => pin.selected).map(pin => pin[axis]));

        const updatedPins = [...svgPins];
        for (let i = 0; i < updatedPins.length; i++) {
            if (updatedPins[i].selected) {
                updatedPins[i][axis] = targetPos;
            }
        }

        this.setState({
            svgPins: updatedPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    flipPins = () => {
        const { svgPins } = this.state;
        const selectedPins = svgPins.filter(pin => pin.selected);

        // Return early if less than 2 pins are selected
        if (selectedPins.length < 2) {
            return;
        }

        // Store original positions
        const positions = selectedPins.map(pin => pin.y);

        // Sort pins by vertical position
        selectedPins.sort((a, b) => a.y - b.y);

        // Reverse the positions array to flip the order
        positions.reverse();

        // Create a map of pin id to new position
        const newPositions = new Map();
        selectedPins.forEach((pin, index) => {
            newPositions.set(pin.id, positions[index]);
        });

        // Update pins with new positions
        for (let i = 0; i < svgPins.length; i++) {
            if (svgPins[i].selected && newPositions.has(svgPins[i].id)) {
                svgPins[i].y = newPositions.get(svgPins[i].id);
            }
        }

        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    setBoardConfigValue = (key, value) => {
        const { boardConfig } = this.state;
        this.setState({
            boardConfig: {
                ...boardConfig,
                [key]: value,
            },
        }, this.saveToLocalStorage);
    }

    getJSON = () => {
        const boardConfig = this.state.boardConfig;
        const json = {
            $schema: '../boardDefinitionSchema.json',
            id: boardConfig.id,
            name: boardConfig.name,
            description: boardConfig.description,
            deviceType: 'board',
            runtimes: boardConfig.runtimes ? boardConfig.runtimes : [],
            ram: boardConfig.ram,
            flash: boardConfig.flash,
            meta: boardConfig.meta,
            capabilities: boardConfig.capabilities ? boardConfig.capabilities : [],
            peripherals: boardConfig.peripherals,
            pins: this.state.pins,
            svgPins: this.state.svgPins,
            pinProps: this.state.propsPins,
            uploadMethods: boardConfig.uploadMethods ? boardConfig.uploadMethods : [],
        };
        return json;
    }

    clearAll = async () => {
        if (!await window.confirm('Are you sure you want to clear all data?')) {
            return;
        }
        this.setState({
            svgSource: '',
            pins: [],
            editingPin: undefined,
            boardConfig: {},
        });
    }

    handleFileChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type !== 'application/json') {
                console.log('incorrect file format');
                return;
            }
            const readFile = new FileReader();
            readFile.onload = (e) => {
                const data = e.target.result;

                const parsed = JSON.parse(data);
                this.setState({
                    boardConfig: parsed,
                    pins: parsed.pins,
                }, this.saveToLocalStorage);
            };
            readFile.readAsText(file);
            document.getElementById('input-file-upload').value = '';
        }
    }

    swapSvgPins = (index1, index2) => {
        const { svgPins } = this.state;
        const temp = svgPins[index1];
        svgPins[index1] = svgPins[index2];
        svgPins[index2] = temp;
        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    renderPeripherals = (pin, index) => {
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        const { pins } = this.state;
                        pins[index].peripherals.push({
                            peripheralType: 'gpio',
                            peripheralPort: '',
                            peripheralPinName: 'PIN',
                            num: '',
                        });
                        this.setState({ pins }, this.saveToLocalStorage);
                    }}
                >
                    Add Peripheral
                </button>
                {pin.peripherals.map((peripheral, j) => (
                    <div key={j}>
                        <hr />
                        <div className="form-group">
                            <label htmlFor="peripheralType">
                                Peripheral Type
                            </label>
                            <select
                                className="form-control"
                                id="peripheralType"
                                value={peripheral.peripheralType}
                                onChange={e => this.setPeripheralValue(index, j, 'peripheralType', e.target.value)}
                            >
                                <option value="" />
                                <option value="gpio">GPIO</option>
                                <option value="uart">UART</option>
                                <option value="i2c">I2C</option>
                                <option value="spi">SPI</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="peripheralPort">
                                Peripheral Port
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="peripheralPort"
                                value={peripheral.peripheralPort}
                                onChange={e => this.setPeripheralValue(index, j, 'peripheralPort', e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="peripheralPinName">
                                Peripheral Pin Name
                            </label>
                            <select
                                className="form-control"
                                id="peripheralPinName"
                                value={peripheral.peripheralPinName}
                                onChange={e => this.setPeripheralValue(index, j, 'peripheralPinName', e.target.value)}
                            >
                                <option value="" />
                                <option value="PIN">PIN</option>
                                <option value="TX">TX</option>
                                <option value="RX">RX</option>
                                <option value="SCL">SCL</option>
                                <option value="SDA">SDA</option>
                                <option value="MISO">MISO</option>
                                <option value="MOSI">MOSI</option>
                                <option value="SCK">SCK</option>
                                <option value="CS">CS</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="num">
                                Num (Pin number in port)
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="num"
                                value={peripheral.num}
                                onChange={e => this.setPeripheralValue(index, j, 'num', e.target.value)}
                            />
                        </div>
                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                const { pins } = this.state;
                                pins[index].peripherals.splice(j, 1);
                                this.setState({ pins }, this.saveToLocalStorage);
                            }}
                        >
                            Remove Peripheral
                        </button>
                    </div>
                ))}
            </div>
        );
    }

    addSvgPin = () => {
        const {
            svgPins, pinsToAdd, addPinDirection, settings,
        } = this.state;

        for (let i = 0; i < pinsToAdd; i++) {
            let newPin = {
                x: 0,
                y: 0,
                id: 0,
                num: '0',
                label: '0',
            };
            if (svgPins.length > 0) {
                let { num, label } = svgPins[svgPins.length - 1];
                const { id } = svgPins[svgPins.length - 1];
                num = Number.isNaN(parseInt(num, 10)) ? '' : parseInt(num, 10) + 1;
                label = Number.isNaN(parseInt(label, 10)) ? '' : parseInt(label, 10) + 1;
                const lastPin = svgPins[svgPins.length - 1];
                const spacing = 18 + settings.pinSpacing; // Base pin size (18) plus spacing value

                let x = lastPin.x;
                let y = lastPin.y;

                switch (addPinDirection) {
                    case 'down':
                        y = lastPin.y + spacing;
                        break;
                    case 'right':
                        x = lastPin.x + spacing;
                        break;
                    case 'left':
                        x = lastPin.x - spacing;
                        break;
                    case 'top':
                        y = lastPin.y - spacing;
                        break;
                    default:
                        break;
                }

                newPin = {
                    ...newPin,
                    id: id + 1,
                    num: num.toString(),
                    label: label.toString(),
                    x,
                    y,
                };
            }
            svgPins.push(newPin);
        }
        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    deleteSvgPin = (index) => {
        const { svgPins } = this.state;
        svgPins.splice(index, 1);
        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }

    undo = () => {
        const { historyIndex, history } = this.state;
        if (historyIndex > 0) {
            const previousState = history[historyIndex - 1];
            this.setState({
                svgSource: previousState.svgSource,
                svgPins: previousState.svgPins,
                historyIndex: historyIndex - 1,
            }, this.validateSvgPins);
        }
    }

    redo = () => {
        const { historyIndex, history } = this.state;
        if (historyIndex < history.length - 1) {
            const nextState = history[historyIndex + 1];
            this.setState({
                svgSource: nextState.svgSource,
                svgPins: nextState.svgPins,
                historyIndex: historyIndex + 1,
            }, this.validateSvgPins);
        }
    }

    generateSvgTemplate = () => {
        const {
            colorBoard,
            colorSoc,
            colorText,
            textValue,
            widthSoc,
            heightSoc,
            width,
            height,
            pinsLeft,
            pinsRight,
        } = this.state.template;
        const board = `<rect x="0" y="0" width="${width}" height="${height}" fill="${colorBoard}" stroke="#fff" strokeWidth="2" />`;
        const chipGroup = `<g id="chip-element">
            <rect x="${(width - widthSoc) / 2}" y="${(height - heightSoc) / 2}" width="${widthSoc}" height="${heightSoc}" fill="${colorSoc}" stroke="#fff" strokeWidth="2" />
            <text x="${(width) / 2 - textValue.length * 4}" y="${(height - heightSoc) / 2 + heightSoc - 10}" strokeWidth="2px" stroke="${colorText}" fill="${colorText}">${textValue}</text>
        </g>`;
        let pins = '';
        const pinWidth = 18;
        const pinHeight = 18;

        // Left side pins
        for (let i = 0; i < pinsLeft; i++) {
            const y = i * height / pinsLeft + 2;
            pins += `
                    <g>
                        <rect id="pin-${i}" x="0" y="${y}" width="${pinWidth}" height="${pinHeight}" data-pin="" class="pin"></rect>
                        <text class="pinLabel" x="${pinWidth / 3}" y="${y + pinWidth * 0.8}" fill="#666" font-size="${pinWidth / 20}em"></text>
                    </g>
                `;
        }

        // Right side pins
        for (let i = 0; i < pinsRight; i++) {
            const y = i * height / pinsRight + 2;
            const x = width - pinWidth;
            pins += `
                    <g>
                        <rect id="pin-${i + pinsLeft}" x="${x}" y="${y}" width="${pinWidth}" height="${pinHeight}" data-pin="" class="pin"></rect>
                        <text class="pinLabel" x="${x + pinWidth / 3}" y="${y + pinHeight * 0.8}" fill="#666" font-size="${pinHeight / 20}em"></text>
                    </g>
                `;
        }

        const svgSource = `<svg xmlns="http://www.w3.org/2000/svg"
    font-family="'Droid Sans'" width="${width}" height="${height}">
                ${board}
                ${chipGroup}
                 <!--PINS_START--><g>
                    ${pins}
                </g><!--PINS_END-->
            </svg>`;
        const svgPins = PlatformUtils.parseSvgPins(svgSource) || [];
        const { width: svgWidth, height: svgHeight } = this.getSvgSize(svgSource);
        this.setState({
            svgSource,
            svgPins,
            width: svgWidth,
            height: svgHeight,
        }, () => {
            this.saveToLocalStorage();
        });
    }

    saveToHistory = () => {
        const {
            svgSource, svgPins, history, historyIndex,
        } = this.state;
        const newHistory = history.slice(0, historyIndex + 1);
        newHistory.push({ svgSource, svgPins: JSON.parse(JSON.stringify(svgPins)) });

        if (newHistory.length > 5) {
            newHistory.shift();
        }

        this.setState({
            history: newHistory,
            historyIndex: newHistory.length - 1,
        });
    }

    updateSvgPinsMap() {
        const pins = svgRef.current.querySelectorAll('.pin');
        for (let i = 0; i < pins.length; i++) {
            const pin = pins[i];
            const pinPos = pin.getBBox();
            const pinAbsPos = pin.getBoundingClientRect();
            this.svgPinsMap.set(parseInt(pin.getAttribute('id').replace('pin-', ''), 10), {
                x: pinPos.x,
                y: pinPos.y,
                absX: pinAbsPos.x,
                absY: pinAbsPos.y,
                pin,
            });
        }
    }

    editSvgPin(index, key, value) {
        const { svgPins } = this.state;
        svgPins[index][key] = value;
        this.setState({
            svgPins,
        }, () => {
            this.updateSvgSource();
        });
    }


    handleChipMouseDown(e) {
        if (!e.target.closest('#chip-element')) return;

        // Prevent default to avoid text selection during drag
        e.preventDefault();

        const chipElement = document.getElementById('chip-element');
        if (!chipElement) return;

        const svgPos = svgRef.current.getBoundingClientRect();
        const scale = scaleRef.current;

        // Calculate mouse position in SVG coordinates
        const mouseX = (e.clientX - svgPos.x) / scale;
        const mouseY = (e.clientY - svgPos.y) / scale;

        this.chipDragState = {
            isDragging: true,
            startX: mouseX,
            startY: mouseY,
            lastX: mouseX,
            lastY: mouseY,
        };
    }

    handleChipMouseMove(e) {
        if (!this.chipDragState.isDragging) return;

        const svgPos = svgRef.current.getBoundingClientRect();
        const scale = scaleRef.current;

        // Calculate current mouse position in SVG coordinates
        const mouseX = (e.clientX - svgPos.x) / scale;
        const mouseY = (e.clientY - svgPos.y) / scale;

        // Calculate the delta from the last position
        const deltaX = mouseX - this.chipDragState.lastX;
        const deltaY = mouseY - this.chipDragState.lastY;

        // Update the last position
        this.chipDragState.lastX = mouseX;
        this.chipDragState.lastY = mouseY;

        // Move the chip element
        const chipElement = document.getElementById('chip-element');
        if (chipElement) {
            // Use transform to move the element
            const currentTransform = chipElement.getAttribute('transform') || '';
            const translateMatch = currentTransform.match(/translate\(([^,]+),([^)]+)\)/);

            let currentX = 0;
            let currentY = 0;

            if (translateMatch) {
                currentX = parseFloat(translateMatch[1]);
                currentY = parseFloat(translateMatch[2]);
            }

            const newX = currentX + deltaX;
            const newY = currentY + deltaY;

            chipElement.setAttribute('transform', `translate(${newX},${newY})`);
        }
    }

    handleChipMouseUp() {
        if (!this.chipDragState.isDragging) return;

        this.chipDragState.isDragging = false;

        // Update the SVG source to save the new position
        const chipElement = document.getElementById('chip-element');
        if (chipElement) {
            // Use debounce to avoid too many state updates
            clearTimeout(debounce);
            debounce = setTimeout(() => {
                // Get the current SVG source
                let { svgSource } = this.state;
                const { template } = this.state;
                const { colorSoc, colorText, textValue } = template;

                // Get the actual rect and text elements
                const rectElement = chipElement.querySelector('rect');
                const textElement = chipElement.querySelector('text');

                if (rectElement && textElement) {
                // Get the current transform of the chip element
                    const transform = chipElement.getAttribute('transform') || '';
                    let deltaX = 0;
                    let deltaY = 0;

                    // Extract translation values if they exist
                    const translateMatch = transform.match(/translate\(([^,]+),([^)]+)\)/);
                    if (translateMatch) {
                        deltaX = parseFloat(translateMatch[1]);
                        deltaY = parseFloat(translateMatch[2]);
                    }

                    // Get the original positions
                    const rectX = parseFloat(rectElement.getAttribute('x'));
                    const rectY = parseFloat(rectElement.getAttribute('y'));
                    const rectWidth = parseFloat(rectElement.getAttribute('width'));
                    const rectHeight = parseFloat(rectElement.getAttribute('height'));
                    const textX = parseFloat(textElement.getAttribute('x'));
                    const textY = parseFloat(textElement.getAttribute('y'));

                    // Calculate the final positions including the transform
                    const finalRectX = rectX + deltaX;
                    const finalRectY = rectY + deltaY;
                    const finalTextX = textX + deltaX;
                    const finalTextY = textY + deltaY;

                    // Create new chip content with the final positions
                    const newChipContent = `<g id="chip-element">
                        <rect x="${finalRectX}" y="${finalRectY}" width="${rectWidth}" height="${rectHeight}" fill="${colorSoc}" stroke="#fff" strokeWidth="2" />
                        <text x="${finalTextX}" y="${finalTextY}" strokeWidth="2px" stroke="${colorText}" fill="${colorText}">${textValue}</text>
                    </g>`;

                    // Extract the chip element from the SVG source
                    const chipRegex = /<g id="chip-element"[^>]*>[\s\S]*?<\/g>/;

                    // Replace the old chip content with the new one
                    svgSource = svgSource.replace(chipRegex, newChipContent);

                    // Remove any transform from the visual element
                    // chipElement.removeAttribute('transform');

                    // Update the state with the new SVG source
                    this.setState({
                        svgSource,
                    }, () => {
                        chipElement.removeAttribute('transform');
                        this.saveToLocalStorage();
                        this.updateSvgPinsMap();
                    });
                }
            }, debounceTimeout);
        }
    }

    openSocEditor() {
        // Initialize the editor state with current template values
        const {
            colorSoc, colorText, textValue, widthSoc, heightSoc,
        } = this.state.template;
        this.setState({
            socEditorModal: true,
            socEditorState: {
                colorSoc,
                colorText,
                textValue,
                widthSoc,
                heightSoc,
            },
        });
    }

    closeSocEditor() {
        this.setState({ socEditorModal: false });
    }

    updateSocEditorState(field, value) {
        this.setState(prevState => ({
            socEditorState: {
                ...prevState.socEditorState,
                [field]: value,
            },
        }));
    }

    applySocChanges() {
        // Apply the changes to the template
        this.setState(prevState => ({
            template: {
                ...prevState.template,
                ...prevState.socEditorState,
            },
            socEditorModal: false,
        }), () => {
            // Update the SVG with the new SOC properties
            this.updateSocInSvg();
        });
    }

    updateSocInSvg() {
        const { svgSource } = this.state;
        const {
            colorSoc, colorText, textValue, widthSoc, heightSoc,
        } = this.state.template;
        const { centerChip } = this.state.socEditorState;

        // Extract the chip element from the SVG source
        const chipRegex = /<g id="chip-element"[^>]*>[\s\S]*?<\/g>/;
        const chipMatch = svgSource.match(chipRegex);

        if (chipMatch) {
            let rectX;
            let rectY;
            const { width, height } = this.state;

            if (centerChip) {
                // Calculate centered positions
                rectX = (width - widthSoc) / 2;
                rectY = (height - heightSoc) / 2;
            } else {
                // Get the current chip element
                const chipElement = document.getElementById('chip-element');
                const rectElement = chipElement ? chipElement.querySelector('rect') : null;

                if (rectElement) {
                    // Keep current position
                    rectX = parseFloat(rectElement.getAttribute('x'));
                    rectY = parseFloat(rectElement.getAttribute('y'));
                } else {
                    // Default position if element not found
                    rectX = (width - widthSoc) / 2;
                    rectY = (height - heightSoc) / 2;
                }
            }

            // Calculate text position (centered at bottom of SOC)
            const textX = rectX + (widthSoc / 2) - (textValue.length * 4);
            const textY = rectY + heightSoc - 10;

            // Create new chip content with updated properties
            const newChipContent = `<g id="chip-element">
                <rect x="${rectX}" y="${rectY}" width="${widthSoc}" height="${heightSoc}" fill="${colorSoc}" stroke="#fff" strokeWidth="2" />
                <text x="${textX}" y="${textY}" strokeWidth="2px" stroke="${colorText}" fill="${colorText}">${textValue}</text>
            </g>`;

            // Replace the old chip content with the new one
            const updatedSvgSource = svgSource.replace(chipRegex, newChipContent);

            // Update the state with the new SVG source
            this.setState({
                svgSource: updatedSvgSource,
            }, () => {
                this.saveToLocalStorage();
            });
        }
    }

    render() {
        const { settings } = this.state;
        const totalSpacing = settings.useCustomSpacing ? settings.pinSpacing : null;
        const horizontalTooltip = settings.useCustomSpacing
            ? `Space ${totalSpacing}px between pins horizontally`
            : 'Space Evenly Horizontally';
        const verticalTooltip = settings.useCustomSpacing
            ? `Space ${totalSpacing}px between pins vertically`
            : 'Space Evenly Vertically';

        let selectedPin;
        if (this.state.editingPin !== undefined) {
            selectedPin = this.state.pins[this.state.editingPin];
        }

        const sourceReplaceRegex = new RegExp(`${startMarker}([\\s\\S]*)${endMarker}`, 'g');
        const source = this.state.svgSource.replace(sourceReplaceRegex, '');

        const selectedPins = this.state.editingPin !== undefined
        && this.state.svgPins[this.state.editingPin]
            ? [this.state.svgPins[this.state.editingPin]]
            : this.state.svgPins.filter(p => p.selected);

        return (
            <>
                <Header />
                <div
                    className="container-fluid h-100"
                    style={{
                        paddingTop: '60px',
                    }}
                >
                    <div className="row h-100">
                        <Resizable
                            resize="right"
                            panelId="boardDesignerLeft"
                            className="h-100"
                            minWidth={300}
                        >
                            <div className="col-md-12 h-100 overflow-scroll">
                                <Tabs
                                    defaultActiveKey={0}
                                >
                                    <Tab
                                        eventKey="0"
                                        title="General"
                                        key={0}
                                    >
                                        <div className="col-md-12">
                                            <div className="form-group mb-1">
                                                <label htmlFor="id">
                                                    ID
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="id"
                                                    value={this.state.boardConfig.id}
                                                    onChange={e => this.setBoardConfigValue('id', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="name">
                                                    Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    value={this.state.boardConfig.name}
                                                    onChange={e => this.setBoardConfigValue('name', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="description">
                                                    Description
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    id="description"
                                                    value={this.state.boardConfig.description}
                                                    onChange={e => this.setBoardConfigValue('description', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="link">
                                                    Link
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="link"
                                                    value={this.state.boardConfig.link}
                                                    onChange={e => this.setBoardConfigValue('link', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="image">
                                                    Image
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="image"
                                                    value={this.state.boardConfig.image}
                                                    onChange={e => this.setBoardConfigValue('image', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="manufacturer">
                                                    Manufacturer
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="manufacturer"
                                                    value={this.state.boardConfig.manufacturer}
                                                    onChange={e => this.setBoardConfigValue('manufacturer', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="ram">
                                                    RAM(Bytes)
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="ram"
                                                    value={this.state.boardConfig.ram}
                                                    onChange={e => this.setBoardConfigValue('ram', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="flash">
                                                    Flash(Bytes)
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="flash"
                                                    value={this.state.boardConfig.flash}
                                                    onChange={e => this.setBoardConfigValue('flash', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="flashAddress">
                                                    Flash Address
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="flashAddress"
                                                    value={this.state.boardConfig.flashAddress}
                                                    onChange={e => this.setBoardConfigValue('flashAddress', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="runtimes">
                                                    Runtimes
                                                </label>
                                                <Select
                                                    isMulti
                                                    id="runtimes"
                                                    className=""
                                                    options={runtimeOptions}
                                                    value={this.getJSON().runtimes.map(r => ({
                                                        value: r,
                                                        label: runtimeOptions
                                                            .find(rt => rt.value === r).label,
                                                    }))}
                                                    onChange={(change) => {
                                                        this.setBoardConfigValue('runtimes', change.map(c => c.value));
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="capabilities">
                                                    Capabilities
                                                </label>
                                                <Select
                                                    isMulti
                                                    id="capabilities"
                                                    className=""
                                                    options={capabilitiesOptions.map(c => ({
                                                        value: c.name,
                                                        label: c.description,
                                                    }))}
                                                    value={this.getJSON().capabilities.map(r => ({
                                                        value: r,
                                                        label: capabilitiesOptions
                                                            .find(rt => rt.name === r)
                                                            ?.description || r,
                                                    }))}
                                                    onChange={(change) => {
                                                        this.setBoardConfigValue('capabilities', change.map(c => c.value));
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="uploadMethods">
                                                    Upload Methods
                                                </label>
                                                <Select
                                                    isMulti
                                                    id="uploadMethods"
                                                    className=""
                                                    options={uploaderOptions}
                                                    value={this.getJSON().uploadMethods.map(r => ({
                                                        value: r,
                                                        label: uploaderOptions
                                                            .find(rt => rt.value === r.name)
                                                            ?.label || r.name,
                                                    }))}
                                                    onChange={(change) => {
                                                        this.setBoardConfigValue('uploadMethods', change.map(c => c.value));
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="metaZephyrName">
                                                    Zephyr Device Tree Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="metaZephyrName"
                                                    value={this.state.boardConfig.meta ? this.state.boardConfig.meta.zephyrName : ''}
                                                    onChange={e => this.setBoardConfigValue('meta', {
                                                        ...this.state.boardConfig.meta,
                                                        zephyrName: e.target.value,
                                                    })}
                                                />
                                            </div>
                                            <div className="form-group mb-1">
                                                <label htmlFor="metaJLinkName">
                                                    JLink Device Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="metaJLinkName"
                                                    value={this.state.boardConfig.meta ? this.state.boardConfig.meta.jlinkName : ''}
                                                    onChange={e => this.setBoardConfigValue('meta', {
                                                        ...this.state.boardConfig.meta,
                                                        jlinkName: e.target.value,
                                                    })}
                                                />
                                            </div>
                                            <br />
                                            <hr />
                                            <br />
                                            <textarea
                                                className="form-control"
                                                placeholder="svg"
                                                rows="10"
                                                value={JSON.stringify(this.getJSON(), null, 4)}
                                            // onChange={e => this.setSvgSource(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-primary mt-1"
                                                onClick={() => {
                                                    const buf = Buffer.from(JSON.stringify(
                                                        this.getJSON(), null, 4,
                                                    ));
                                                    const blob = new Blob([buf], {
                                                        type: 'application/octet-stream',
                                                    });
                                                    saveAs(blob, `${this.state.boardConfig.id}.json`);
                                                }}
                                            >
                                                Export
                                            </button>

                                            <input id="input-file-upload" type="file" accept=".json" style={{ display: 'none' }} onChange={this.handleFileChange} />
                                            <label htmlFor="input-file-upload">
                                                <div
                                                    className="btn btn-secondary mt-1 ms-1"
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    Import File
                                                </div>
                                            </label>

                                            <button
                                                type="button"
                                                className="btn btn-danger mt-1 ms-1"
                                                onClick={this.clearAll}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </Tab>
                                    <Tab
                                        eventKey="1"
                                        title="Pins"
                                        key={1}
                                    >
                                        {this.state.editingPin === undefined ? (
                                            <div className="row p-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary col-md-12 mt-1 mb-1"
                                                    onClick={this.addPin}
                                                >
                                                    Add Pin
                                                </button>
                                                <table className="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Pin Number</th>
                                                            <th>Function</th>
                                                            <th>Description</th>
                                                            <th>Peripherals</th>
                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.pins.map((pin, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    {pin.num}
                                                                </td>
                                                                <td>
                                                                    {pin.function}
                                                                </td>
                                                                <td>
                                                                    {pin.description}
                                                                </td>
                                                                <td>
                                                                    {pin.peripherals
                                                                        .map((peripheral, j) => (
                                                                            <span key={j}>
                                                                                {`${peripheral.peripheralType}(${peripheral.peripheralPort} - ${peripheral.peripheralPinName} - ${peripheral.num})`}
                                                                            </span>
                                                                        ))}
                                                                </td>
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={() => this
                                                                            .setState({
                                                                                editingPin: index,
                                                                            })}
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="mb-1 bg-light">
                                                <div className="form-group">
                                                    <label htmlFor="num">
                                                        Num
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="num"
                                                        value={selectedPin.num}
                                                        onChange={e => this.setPinValue(this.state.editingPin, 'num', e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="description">
                                                        Description
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="description"
                                                        value={selectedPin.description}
                                                        onChange={e => this.setPinValue(this.state.editingPin, 'description', e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="function">
                                                        Function
                                                    </label>
                                                    <select
                                                        className="form-control"
                                                        id="function"
                                                        value={selectedPin.function}
                                                        onChange={e => this.setPinValue(
                                                            this.state.editingPin,
                                                            'function',
                                                            e.target.value,
                                                        )}
                                                    >
                                                        <option value="GPIO">GPIO</option>
                                                        <option value="GND">GND</option>
                                                        <option value="VBAT">VBAT</option>
                                                        <option value="EN">EN</option>
                                                        <option value="VBUS">VBUS</option>
                                                        <option value="NC">N.C.</option>
                                                        <option value="VDD">VDD</option>
                                                        <option value="RESET">RESET</option>
                                                        <option value="5V">5V</option>
                                                        <option value="3V3">3V3</option>
                                                        <option value="3V">3V</option>
                                                    </select>
                                                    {/* <input
                                                        type="text"
                                                        className="form-control"
                                                        id="function"
                                                        value={selectedPin.function}
                                                        onChange={e => this.setPinValue(
                                                            this.state.editingPin,
                                                            'function',
                                                            e.target.value,
                                                        )}
                                                    /> */}
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="constant">
                                                        Constant
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="constant"
                                                        value={selectedPin.constant}
                                                        onChange={e => this.setPinValue(this.state.editingPin, 'constant', e.target.value)}
                                                    />
                                                </div>
                                                {this.renderPeripherals(selectedPin,
                                                    this.state.editingPin)}
                                                <br />
                                                <br />
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => this.setState({
                                                        editingPin: undefined,
                                                    })}
                                                >
                                                    Close
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-danger ms-1"
                                                    onClick={() => {
                                                        const pins = { pins };
                                                        pins.splice(this.state.editingPin, 1);
                                                        this.setState({
                                                            pins,
                                                            editingPin: undefined,
                                                        }, this.saveToLocalStorage);
                                                    }}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        )}
                                    </Tab>
                                    <Tab
                                        eventKey="2"
                                        title="Peripherals"
                                        key={2}
                                    >
                                        <div className="col-md-12">
                                            peripherals
                                        </div>
                                    </Tab>
                                    <Tab
                                        eventKey="3"
                                        title={this.state.svgPinsErrors.length > 0
                                            ? (
                                                <div className="d-inline-block text-danger">
                                                    SVG
                                                    <FaExclamationTriangle className="ms-1" />
                                                    <span className="ms-1">
                                                    (
                                                        {this.state.svgPinsErrors.length}
                                                    )
                                                    </span>
                                                </div>
                                            )
                                            : 'SVG'
                                        }
                                        key={3}
                                    >
                                        <div className="col-md-12">
                                            svg
                                            <textarea
                                                className="form-control"
                                                placeholder="svg"
                                                rows="10"
                                                value={this.state.svgSource}
                                                onChange={e => this.setSvgSource(e.target.value)}
                                            />
                                            <Button
                                                onClick={() => {
                                                    navigator.clipboard
                                                        .writeText(this.state.svgSource);
                                                }}
                                                className="my-2"
                                            >
                                                Copy to clipboard
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                onClick={() => {
                                                    this.setState({
                                                        templateCreatorModal: true,
                                                    });
                                                }}
                                                className="mx-2"
                                            >
                                                Generate template
                                            </Button>
                                            <Button
                                                variant="info"
                                                onClick={this.openSocEditor}
                                            >
                                                Edit SOC
                                            </Button>
                                        </div>
                                        <div
                                            className="mt-3"
                                        >
                                            {
                                                this.state.svgPins.length > 0 && (
                                                    <Table striped hover>
                                                        <thead>
                                                            <tr>
                                                                <th />
                                                                <th>Num</th>
                                                                <th>Label</th>
                                                                <th />
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.pinProps.map((pin, index) => {
                                                                return (
                                                                    <DraggableElement
                                                                        key={index}
                                                                        index={index}
                                                                        swapElements={(dragIndex, hoverIndex) => {
                                                                            this.swapSvgPins(dragIndex, hoverIndex);
                                                                        }}
                                                                        className={pin.error ? 'table-danger' : ''}
                                                                        draggableType="draggable-svg-pins"
                                                                        onMouseDown={(e) => {
                                                                            if (e.shiftKey) {
                                                                                const svgPos = svgRef.current.getBoundingClientRect();
                                                                                const scale = scaleRef.current;
                                                                                const x = (e.clientX - svgPos.x) / scale;
                                                                                const y = (e.clientY - svgPos.y) / scale;
                                                                                selectAreaStateRef.current = {
                                                                                    isSelecting: true,
                                                                                    x,
                                                                                    y,
                                                                                    startX: x,
                                                                                    startY: y,
                                                                                    width: 0,
                                                                                    height: 0,
                                                                                };
                                                                                return;
                                                                            }
                                                                            if (e.ctrlKey) {
                                                                                return;
                                                                            }
                                                                            selectAreaStateRef.current = {
                                                                                isSelecting: false,
                                                                                x: 0,
                                                                                y: 0,
                                                                                startX: 0,
                                                                                startY: 0,
                                                                                width: 0,
                                                                                height: 0,
                                                                            };
                                                                            this.updateSelectedPins();
                                                                        }}
                                                                        onMouseMove={this.handleGlobalMouseMove}
                                                                        onMouseUp={this.handleGlobalMouseUp}
                                                                    >
                                                                        <td>
                                                                            <Select
                                                                                isMulti={false}
                                                                                options={this.state.selectPinOptions}
                                                                                defaultValue={{
                                                                                    value: pin.num,
                                                                                    label: `${pin.num}${pin.description ? ` - ${pin.description}` : ''}`,
                                                                                }}
                                                                                onChange={(change) => {
                                                                                    this.editSvgPin(index, 'num', change.value);
                                                                                }}
                                                                            />
                                                                            {pin.error && (
                                                                                <small className="text-danger">
                                                                                    {pin.errorMessage}
                                                                                </small>
                                                                            )}
                                                                        </td>
                                                                        <td>
                                                                            <input
                                                                                type="text"
                                                                                className={`form-control ${pin.error ? 'is-invalid' : ''}`}
                                                                                defaultValue={pin.label}
                                                                                onChange={e => this.editSvgPin(index, 'label', e.target.value)}
                                                                            />
                                                                        </td>
                                                                        <td>
                                                                            <Button
                                                                                variant="danger"
                                                                                onClick={() => this.deleteSvgPin(index)}
                                                                            >
                                                                                X
                                                                            </Button>
                                                                        </td>
                                                                    </DraggableElement>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                )
                                            }
                                            <div className="d-inline-flex align-items-center">
                                                <div>Add</div>
                                                <input
                                                    type="text"
                                                    className="form-control mx-1"
                                                    value={this.state.pinsToAdd}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (Number.isNaN(value)) {
                                                            return;
                                                        }
                                                        this.setState({
                                                            pinsToAdd: Number(value),
                                                        });
                                                    }}
                                                />
                                                <div>pin(s)</div>
                                                <select
                                                    className="form-control mx-1"
                                                    value={this.state.addPinDirection}
                                                    onChange={e => this.setState({ addPinDirection: e.target.value })}
                                                >
                                                    <option value="down">Down</option>
                                                    <option value="right">Right</option>
                                                    <option value="left">Left</option>
                                                    <option value="top">Top</option>
                                                </select>
                                                <Button
                                                    onClick={this.addSvgPin}
                                                    className="ms-2"
                                                >
                                                    Add
                                                </Button>
                                                <Button
                                                    variant="danger"
                                                    className="ms-2 w-100"
                                                    onClick={() => {
                                                        const { svgPins } = this.state;
                                                        const newSvgPins = [];
                                                        for (let i = 0; i < svgPins.length; i++) {
                                                            if (!svgPins[i].selected) {
                                                                newSvgPins.push(svgPins[i]);
                                                            }
                                                        }
                                                        if (newSvgPins.length === svgPins.length || !window.confirm('Are you sure you want to delete selected pins?')) {
                                                            return;
                                                        }
                                                        this.setState(() => {
                                                            return {
                                                                svgPins: newSvgPins,
                                                            };
                                                        }, () => {
                                                            this.updateSvgSource();
                                                        });
                                                    }}
                                                >
                                                    Delete Selected
                                                </Button>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </Resizable>
                        <div className="h-100" style={{ flex: 1 }}>
                            <div className="h-100 bg-secondary">
                                <ButtonGroup
                                    vertical
                                    className="m-1 board-designer__controls"
                                    style={{
                                        position: 'absolute',
                                        zIndex: 1,
                                        width: '20px',
                                    }}
                                >
                                    <ControlButton
                                        onClick={this.undo}
                                        tooltipText="Undo"
                                        disabled={this.state.historyIndex <= 0}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16">
                                            <path d="M8 3.5a5 5 0 0 0-5 5V9h2V8.5a3 3 0 1 1 3 3H4v2h4a5 5 0 0 0 0-10z" />
                                        </svg>
                                    </ControlButton>
                                    <ControlButton
                                        onClick={this.redo}
                                        tooltipText="Redo"
                                        disabled={this.state.historyIndex >= this.state.history.length - 1}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16">
                                            <path d="M8 3.5a5 5 0 0 1 5 5V9h-2V8.5a3 3 0 1 0-3 3h4v2H8a5 5 0 0 1 0-10z" />
                                        </svg>
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.spacePinsEvenly('vertical')}
                                        tooltipText={verticalTooltip}
                                    >
                                        <RxSpaceEvenlyVertically />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.spacePinsEvenly('horizontal')}
                                        tooltipText={horizontalTooltip}
                                    >
                                        <RxSpaceEvenlyHorizontally />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.alignPins('left')}
                                        tooltipText="Align Left"
                                    >
                                        <RxAlignLeft />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.alignPins('right')}
                                        tooltipText="Align Right"
                                    >
                                        <RxAlignRight />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.alignPins('top')}
                                        tooltipText="Align Top"
                                    >
                                        <RxAlignTop />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.alignPins('bottom')}
                                        tooltipText="Align Bottom"
                                    >
                                        <RxAlignBottom />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.flipPins()}
                                        tooltipText="Sort/Flip Vertically"
                                    >
                                        <MdOutlineSwapVert />
                                    </ControlButton>
                                    <ControlButton
                                        onClick={() => this.setState({ settingsModal: true })}
                                        tooltipText="Settings"
                                    >
                                        <RxGear />
                                    </ControlButton>
                                </ButtonGroup>
                                <AutoSizer>
                                    {(({ width, height }) => (width === 0 || height === 0 ? null : (
                                        <TransformWrapper
                                            initialScale={scaleRef.current}
                                            panning={{
                                                excluded: ['pin'],
                                                disabled: this.state.isPanningDisabled,
                                                velocityDisabled: true,
                                            }}
                                            disablePadding
                                            ref={transformWrapperRef}
                                            onZoom={(e) => {
                                                scaleRef.current = e.state.scale;
                                            }}
                                        >
                                            <TransformComponent
                                                wrapperStyle={{
                                                    height,
                                                    width,
                                                    backgroundColor: 'rgb(250, 250, 250)',
                                                }}
                                            >
                                                <svg
                                                    width={width}
                                                    height={height}
                                                    ref={svgRef}
                                                    onMouseDown={(e) => {
                                                        if (e.shiftKey) {
                                                            const svgPos = svgRef.current.getBoundingClientRect();
                                                            const scale = scaleRef.current;
                                                            const x = (e.clientX - svgPos.x) / scale;
                                                            const y = (e.clientY - svgPos.y) / scale;
                                                            selectAreaStateRef.current = {
                                                                isSelecting: true,
                                                                x,
                                                                y,
                                                                startX: x,
                                                                startY: y,
                                                                width: 0,
                                                                height: 0,
                                                            };
                                                            return;
                                                        }
                                                        if (e.ctrlKey) {
                                                            return;
                                                        }
                                                        selectAreaStateRef.current = {
                                                            isSelecting: false,
                                                            x: 0,
                                                            y: 0,
                                                            startX: 0,
                                                            startY: 0,
                                                            width: 0,
                                                            height: 0,
                                                        };
                                                        this.updateSelectedPins();
                                                    }}
                                                    onMouseMove={this.handleGlobalMouseMove}
                                                    onMouseUp={this.handleGlobalMouseUp}
                                                >
                                                    <Board
                                                        svg={source}
                                                        pins={this.state.svgPins}
                                                        selectPin={() => {}}
                                                        selectedPins={selectedPins}
                                                        updatePinPosition={this.updatePinPosition}
                                                        highlightPins={this.highlightPins}
                                                        svgRef={svgRef}
                                                    />
                                                    <rect
                                                        x={Math.floor(
                                                            selectAreaStateRef.current.x / scaleRef.current,
                                                        )}
                                                        y={Math.floor(
                                                            selectAreaStateRef.current.y / scaleRef.current,
                                                        )}
                                                        width={Math.floor(
                                                            selectAreaStateRef.current.width / scaleRef.current,
                                                        )}
                                                        height={Math.floor(
                                                            selectAreaStateRef.current.height / scaleRef.current,
                                                        )}
                                                        ref={selectAreaRef}
                                                        fill="#bbb"
                                                        fillOpacity="0.1"
                                                        stroke="#666"
                                                        strokeWidth="1"
                                                        strokeDasharray="5,5"
                                                    />
                                                </svg>
                                            </TransformComponent>
                                        </TransformWrapper>
                                    )))}
                                </AutoSizer>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.templateCreatorModal}
                    onHide={() => this.setState({ templateCreatorModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Generate Template</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup>
                            <InputGroup.Text>Board color</InputGroup.Text>
                            <Form.Control
                                type="color"
                                value={this.state.template.colorBoard}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            colorBoard: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Chip color</InputGroup.Text>
                            <Form.Control
                                type="color"
                                value={this.state.template.colorSoc}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            colorSoc: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Chip text color</InputGroup.Text>
                            <Form.Control
                                type="color"
                                value={this.state.template.colorText}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            colorText: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Width</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.width}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            width: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Height</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.height}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            height: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <div>
                            Min recommended height:
                            &nbsp;
                            {
                                Math.max(this.state.template.pinsLeft,
                                    this.state.template.pinsRight) * 20}
                        </div>
                        <InputGroup>
                            <InputGroup.Text>Width SOC</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.widthSoc}
                                onChange={e => this.setState((prev) => {
                                    if (Number.isNaN(Number(e.target.value))) return;
                                    return {
                                        template: {
                                            ...prev.template,
                                            widthSoc: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Height SOC</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.heightSoc}
                                onChange={e => this.setState((prev) => {
                                    if (Number.isNaN(Number(e.target.value))) return;
                                    return {
                                        template: {
                                            ...prev.template,
                                            heightSoc: Number(e.target.value),
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Text SOC</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.textValue}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            textValue: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Pins left</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.pinsLeft}
                                onChange={e => this.setState((prev) => {
                                    if (Number.isNaN(Number(e.target.value))) return;
                                    return {
                                        template: {
                                            ...prev.template,
                                            pinsLeft: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <InputGroup>
                            <InputGroup.Text>Pins right</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.template.pinsRight}
                                onChange={e => this.setState((prev) => {
                                    return {
                                        template: {
                                            ...prev.template,
                                            pinsRight: e.target.value,
                                        },
                                    };
                                })}
                            />
                        </InputGroup>
                        <Button
                            onClick={this.generateSvgTemplate}
                        >
                            Generate
                        </Button>
                    </Modal.Body>
                </Modal>
                <Modal
                    show={this.state.settingsModal}
                    onHide={() => this.setState({ settingsModal: false })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Settings</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Use custom pin spacing"
                                checked={this.state.settings.useCustomSpacing}
                                onChange={e => this.setState(prev => ({
                                    settings: {
                                        ...prev.settings,
                                        useCustomSpacing: e.target.checked,
                                    },
                                }))}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>
                                Pin spacing:
                                {' '}
                                {this.state.settings.pinSpacing}
                                px
                            </Form.Label>
                            <Form.Range
                                min={2}
                                max={100}
                                value={this.state.settings.pinSpacing}
                                onChange={e => this.setState(prev => ({
                                    settings: {
                                        ...prev.settings,
                                        pinSpacing: Number(e.target.value),
                                    },
                                }))}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => this.setState({ settingsModal: false })}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.socEditorModal}
                    onHide={this.closeSocEditor}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit SOC</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>SOC Color</InputGroup.Text>
                            <Form.Control
                                type="color"
                                value={this.state.socEditorState.colorSoc}
                                onChange={e => this.updateSocEditorState('colorSoc', e.target.value)}
                            />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Text Color</InputGroup.Text>
                            <Form.Control
                                type="color"
                                value={this.state.socEditorState.colorText}
                                onChange={e => this.updateSocEditorState('colorText', e.target.value)}
                            />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Text</InputGroup.Text>
                            <Form.Control
                                type="text"
                                value={this.state.socEditorState.textValue}
                                onChange={e => this.updateSocEditorState('textValue', e.target.value)}
                            />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Width</InputGroup.Text>
                            <Form.Control
                                type="number"
                                value={this.state.socEditorState.widthSoc}
                                onChange={e => this.updateSocEditorState('widthSoc', parseInt(e.target.value, 10))}
                            />
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Text>Height</InputGroup.Text>
                            <Form.Control
                                type="number"
                                value={this.state.socEditorState.heightSoc}
                                onChange={e => this.updateSocEditorState('heightSoc', parseInt(e.target.value, 10))}
                            />
                        </InputGroup>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Center chip on board"
                                checked={this.state.socEditorState.centerChip}
                                onChange={e => this.updateSocEditorState('centerChip', e.target.checked)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeSocEditor}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.applySocChanges}>
                            Apply Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default PageBoardDesigner;
